import { Navbar, Nav, Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { logout } from "../firebase/auth"; // Import logout function 
import { useAuth } from "../firebase/auth"; // Use AuthContext for current user
import { useState, useEffect } from "react"; 
import { doc, getDoc } from "firebase/firestore"; 
import { db } from "../firebase/config"; 
 
function NavbarWithLogout() {
  const navigate = useNavigate();
  const { currentUser } = useAuth(); // Get the current user
  const [roles, setRoles] = useState([]); // State to store user roles 
  const [isAdminFaculty, setIsAdminFaculty] = useState(false); // State to check if the user has both roles 
  const [onAdminDashboard, setOnAdminDashboard] = useState(false); // State to track which dashboard is active 

  // Fetch user roles from Firestore 
  useEffect(() => { 
    const fetchRoles = async () => { 
      if (currentUser) { 
        const userRef = doc(db, "users", currentUser.uid); 
        const userDoc = await getDoc(userRef); 
        if (userDoc.exists()) { 
          const userData = userDoc.data(); 
          setRoles(userData.role || []);  
          if (userData.role.includes("admin") && userData.role.includes("faculty")) { 
            setIsAdminFaculty(true); 
          } 
        } 
      } 
    }; 

    fetchRoles(); 
  }, [currentUser]); 

  // Handle dashboard switch 
  const handleSwitchDashboard = () => { 
    if (onAdminDashboard) { 
      navigate("/faculty/dashboard");
    } else { 
      navigate("/AdministratorDashboard");
    } 
    setOnAdminDashboard(!onAdminDashboard); // Toggle dashboard state 
  }; 
 
  const handleLogout = async () => {
    try {
      await logout(); // Call the logout function from Auth
      navigate("/SimpleLogin"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };
 
  return (
    <Navbar bg="light" expand="lg"> 
    <Container> 
      <Navbar.Brand href="/SimpleLogin">Quiz Retake System</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" /> 
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end"> 
        <Nav className="ml-auto"> 
          <Navbar.Text> 
            Signed in as: <a href="#login">{currentUser && currentUser.email}</a> 
          </Navbar.Text>         
          {/* Conditionally render the switch button if the user has both admin and faculty roles */} 
          {isAdminFaculty && ( 
            <Button variant="outline-primary" className="ms-3 btn-dark-green" onClick={handleSwitchDashboard}> 
              {onAdminDashboard ? "Switch to Faculty Dashboard" : "Switch to Admin Dashboard"} 
            </Button> 
          )} 
          <Button variant="outline-danger" className="ms-3 btn-bright-green" onClick={handleLogout}> 
            Logout 
          </Button> 
        </Nav> 
      </Navbar.Collapse> 
    </Container> 
  </Navbar> 
); 

} 
 
export default NavbarWithLogout;
